// Carrier portali /portal, en — manba
export default {
  accessOnly: "Carrier portal access only.",
  signOut: "Sign out",
  logout: "Logout",
  title: "Carrier Portal",
  nav: { candidates: "Candidates", jobs: "Jobs", account: "Account" },
  poweredBy: "Powered by {{company}}",
  searchPlaceholder: "Search candidates",
  status: { new: "New", in_review: "In review", accepted: "Accepted", rejected: "Rejected" },
  all: "All",
  exp: { none: "—", months: "{{n}} mo", years_one: "{{count}} yr", years_other: "{{count}} yrs" },
  allStates: "48 states",
  candidates: {
    title: "Candidates",
    subtitle: "Drivers submitted to {{carrier}} by {{company}}",
    loadFailed: "Could not load candidates.",
    emptyTitle: "No candidates",
    emptySearch: "Nothing matches \"{{q}}\".",
    emptyDesc: "Drivers submitted by your recruiter will appear here.",
    col: { driver: "Driver", job: "Job", cdl: "CDL / exp.", state: "State", submitted: "Submitted", status: "Status" },
    count: "{{shown}} of {{total}} candidates",
  },
  panel: {
    accepted: "{{name}} accepted",
    acceptedDesc: "The recruiter was notified. The driver moves to background check.",
    rejected: "{{name}} rejected",
    rejectedDesc: "The recruiter was notified.",
    decisionFailed: "Could not save the decision.",
    submitted: "Submitted {{date}} · {{job}}",
    close: "Close details",
    phone: "Phone",
    hidden: "Hidden by recruiter",
    state: "State",
    cdl: "CDL",
    class: "Class {{cls}}",
    cdlExpires: "CDL expires",
    medical: "Medical card",
    validUntil: "valid until {{date}}",
    experience: "Experience",
    endorsements: "Endorsements",
    equipment: "Equipment",
    note: "Note from recruiter",
    yourReply: "Your reply",
    rejectionReason: "Rejection reason",
    documents: "Documents",
    documentsDesc: "Documents (CDL copy, medical card) arrive in a later stage.",
    notShared: "Not shared with carriers: SSN, date of birth, internal notes, results with other carriers.",
    accept: "Accept",
    reject: "Reject",
    acceptTitle: "Accept {{name}}",
    acceptDesc: "The driver moves to background check. The recruiter gets a notification.",
    comment: "Comment",
    commentPlaceholder: "Optional comment for the recruiter",
    rejectTitle: "Reject {{name}}",
    rejectDesc: "{{job}} · the recruiter will see the reason.",
    confirmReject: "Confirm reject",
    rejectReason: "Reject reason",
    chooseReason: "Choose a reason",
    reasons: { mvr: "MVR / driving record", experience: "Experience", drug: "Drug test", psp: "PSP / crash history", noshow: "No-show", other: "Other" },
  },
  jobs: {
    title: "Jobs",
    subtitle: "Your open positions and candidates per job",
    loadFailed: "Could not load jobs.",
    emptyTitle: "No jobs yet",
    emptyDesc: "Your recruiter adds positions on your behalf.",
    col: { job: "Job", status: "Status", states: "States", openings: "Openings", pay: "Pay", homeTime: "Home time", equipment: "Equipment", candidates: "Candidates", inReview: "In review", hired: "Hired" },
    hiredOf: "{{hired}} of {{openings}} hired",
  },
  account: {
    title: "Account",
    card: "Your account",
    name: "Name",
    username: "Username",
    carrier: "Carrier",
    mc: "MC #",
    contact: "Contact your recruiter to change account details.",
  },
};
